import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";
import { makeAdditionalSearchableFeature } from "@navigationRouting/utils";

import type { I18nT } from "@lib/dashboardI18n";

const BannersForNro = lazy(() =>
  import("@scenes/Banners/BannersForNro").then((module) => ({
    default: module.BannersForNro,
  }))
);

export const bannersNRO: NavigationRoutingObject = {
  Component: BannersForNro,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  pageNameForTracking: () => "Banners",
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("banners-sidebar-pill-menu-option", "Banners"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "banners-sidebar-pill-menu-option-description",
      "Create persistent in-app messages that stay visible until dismissed or expired"
    ),
  icon: "nav-system-banner",
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn }) => featureOn("banners_landing_page"),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: (t: I18nT<"dashboard-navigation">) => ({
    banners: makeAdditionalSearchableFeature({
      heading: t("banners-sidebar-pill-menu-option", "Banners"),
      pathname: "/engagement/banners/:appGroupId",
      query: {},
      description: t(
        "banners-sidebar-pill-menu-option-description",
        "Create persistent in-app messages that stay visible until dismissed or expired"
      ),
      additionalSearchTerms: [],
    }),
  }),
  defaultRoute: "/engagement/banners/:appGroupId",
};
